/**
 * S12 SET-01 减少动效 —— 运行时动效配置（Tier E：静态棋盘 + 极简过渡）。
 *
 * 单一配置对象，user 与 auto 两种驱动共用（S12 §2.2 验收断言：同一配置对象）。
 * 导演层的 scaled() / fallDuration() 读取本配置，使减少动效在两条驱动下画面表现完全一致。
 */

export interface MotionConfigType {
  /** 是否启用减少动效（解析值） */
  reduced: boolean;
  /** 动效时长乘数（reduced 时压缩到极简过渡） */
  speedScale: number;
}

export const MotionConfig: MotionConfigType = {
  reduced: false,
  speedScale: 1,
};

/** 由 SettingsStore 在首帧前与每次变更时调用（S12 SET-01 Tier E） */
export function setReducedMotion(on: boolean): void {
  MotionConfig.reduced = on;
  // 减少动效：压缩到极简过渡；normal 恢复全速（user / auto 两套驱动共用同一配置对象）
  MotionConfig.speedScale = on ? 0.04 : 1;
}
